import { create } from 'zustand';
import { AboutContentMode } from '../enum/EnumRepository';

interface AboutViewState {
  aboutContentMode: AboutContentMode;
  setAboutContentMode: (mode: AboutContentMode) => void;
  isExtended: boolean;
  setIsExtended: (isExtended: boolean) => void;
}

export const useAboutViewStore = create<AboutViewState>((set) => ({
  aboutContentMode: AboutContentMode.Orig,
  setAboutContentMode: (mode) => set({ aboutContentMode: mode }),
  isExtended: false,
  setIsExtended: (isExtended) => set({ isExtended }),
}));
